export default __webpack_public_path__ + "static/media/createVersion.d4399c94.svg";